<template>
    <div class="p-grid p-fluid">
        <card-seplag titulo="Retrato Funcional">
            <Panel class="p-col-12" header="Vínculo" :toggleable="true">
                <div class="p-grid">
                    <Rotulo nome=""  cols="12"/>
                    <Rotulo nome="Vínculo:"  cols="6 3">
                        {{this.dadosServidor.vinculo}}
                    </Rotulo>
                    <Rotulo nome="Data nomeação:"  cols="6 3">
                        {{this.dadosServidor.dataNomeacao}}
                    </Rotulo>
                    <Rotulo nome="Data posse:"  cols="6 3">
                        {{this.dadosServidor.dataPosse}}
                    </Rotulo>
                    <Rotulo nome="Data exercício:"  cols="6 3">
                        {{this.dadosServidor.dataExercicio}}
                    </Rotulo>                        
                    <Rotulo nome=""  cols="12"/>
                    <Rotulo nome="Tipo Vínculo:"  cols="6 4">
                        {{this.dadosServidor.tipoVinculo}}
                    </Rotulo>
                    <Rotulo nome="Regime Jurídico:"  cols="6 4">
                        {{this.dadosServidor.regimeJuridico}}
                    </Rotulo>
                    <Rotulo nome="Categoria:"  cols="12 4">
                        ***
                    </Rotulo>
                    <Fieldset legend="Contrato" class="p-col-12 marginTopFieldset" >
                        <div class="p-grid">
                            <Rotulo nome="Data Início:"  cols="6 4">
                                {{this.dadosServidor.dataInicioContrato}}
                            </Rotulo>
                            <Rotulo nome="Data Final:"  cols="6 4">
                                {{this.dadosServidor.dataFimContrato}}
                            </Rotulo>
                            <Rotulo nome="Data Prorrogação:"  cols="6 4">
                                {{this.dadosServidor.dataprorrogacaoContrato}}
                            </Rotulo>
                        </div>
                    </Fieldset>
                    <Fieldset legend="Requisição" class="p-col-12 marginTopFieldset" >
                        <div class="p-grid">
                            <Rotulo nome="Tipo Requisição:"  cols="6">
                                {{this.dadosServidor.tipoOrgaoRequisicao}}
                            </Rotulo>
                            <Rotulo nome="Tipo Órgão:"  cols="6">
                                {{this.dadosServidor.orgaoRequisicao}}
                            </Rotulo>
                            <Rotulo nome=""  cols="12" />
                            <Rotulo nome="Função"  cols="6 3">
                                {{this.dadosServidor.funcaoRequisicao}}
                            </Rotulo>
                            <Rotulo nome="Fone"  cols="6 3">
                                {{this.dadosServidor.foneRequisicao}}
                            </Rotulo>
                            <Rotulo nome="Tipo ônus"  cols="6 3">
                                ***
                            </Rotulo>
                            <Rotulo nome="Tipo Ressarcimento"  cols="6 3">
                                ***
                            </Rotulo>
                        </div>
                    </Fieldset>
                    <Fieldset legend="Aposentadoria" class="p-col-12 marginTopFieldset" >
                        <div class="p-grid">
                            <Rotulo nome="Tipo aposentadoria"  cols="6">
                                {{this.dadosServidor.tipoAposentadoria}}
                            </Rotulo>
                            <Rotulo nome="Data aposentadoria"  cols="6">
                                {{this.dadosServidor.dataAposentadoria}}
                            </Rotulo>
                        </div>
                    </Fieldset>
                    <Fieldset legend="Desligamento" class="p-col-12 marginTopFieldset" >
                        <div class="p-grid">
                            <Rotulo nome="Forma de desligamento"  cols="6">
                                {{this.dadosServidor.formaDesligamento}}
                            </Rotulo>
                            <Rotulo nome="Data de desligamento"  cols="6">
                                {{this.dadosServidor.dataDesligamento}}
                            </Rotulo>
                        </div>
                    </Fieldset>
                    <Fieldset legend="Dados bancários" class="p-col-12 marginTopFieldset" >
                        <div class="p-grid">
                            <Rotulo nome="Código"  cols="6 3">
                                ***
                            </Rotulo>
                            <Rotulo nome="Banco"  cols="6 3">
                                ***
                            </Rotulo>
                            <Rotulo nome="Agência"  cols="6 3">
                                ***
                            </Rotulo>
                            <Rotulo nome="Conta"  cols="6 3">
                                ***
                            </Rotulo>
                        </div>
                    </Fieldset>
                </div>
            </Panel>
            <div class="p-grid p-col-12">
            </div>
            <Panel class="p-col-12"  header="Provimentos" :toggleable="true">
                <div class="p-grid">
                    ***
                </div>
            </Panel>
            <div class="p-grid p-col-12">
            </div>
            <Panel class="p-col-12" header="Dependentes" :toggleable="true">
                    <table-seplag v-if="dependentes.length > 0" :dados="dependentes" :exibirCabecalho="false" :campos="colunasTabelaDependentes">
                    </table-seplag>
                    <label v-if="dependentes.length == 0">Não há dependentes cadastrados</label>
            </Panel>
        </card-seplag>
    </div>
</template>
<script>
import CardSeplag from '@/template/CardSeplag.vue'
import Rotulo from '@/template/RotuloSeplag.vue'
// import FormSeplag from '@/template/FormSeplag.vue'
import { baseApiUrl } from '@/config/global'
import TableSeplag from '@/template/TableSeplag.vue'
import moment from 'moment'

export default {
    name: 'retratoFuncional',
    components: { CardSeplag, Rotulo, TableSeplag},    
    data(){
        return{
            apiUrlRecurso: 'retratofuncional',
            matricula: null,
            vinculo: null,
            dadosServidor: [],
            dependentes: [],
            colunasTabelaDependentes : [
				{ nome: 'numeroDependente', titulo: 'Nº' },
				{ nome: 'grauParentesco', titulo: 'Parentesco' },
                { nome: 'pessoa.nome', titulo: 'Nome' },
                { nome: 'pessoa.dataNascimento', titulo: 'Nascimento' },
                { nome: 'pessoa.documentosPessoais.cpfFormatado', titulo: 'CPF' },
			],
        }
    },
    methods:{
        async carregarDados(){
          this.matricula = this.$store.getters.getMatricula  
          //this.matricula = 8638
          this.vinculo = this.$store.getters.getVinculo

          var result = await this.$http.get(`${baseApiUrl}/${this.apiUrlRecurso}/${this.matricula}/${this.vinculo}`)
          if(result.status==200){
              this.dadosServidor = result.data.vinculoSeap
              for (var i=0; i < this.dadosServidor.listaDependente.length; i++){
                  this.dadosServidor.listaDependente[i].pessoa.dataNascimento = new moment(this.dadosServidor.listaDependente[i].pessoa.dataNascimento).format("DD/MM/YYYY")
                  this.dependentes.push(this.dadosServidor.listaDependente[i])
              }
          }
        }
    },
    mounted(){
        
        this.carregarDados()

    },
    created(){
        
    }
}
</script>
<style scoped>
.marginTopFieldset{
    margin-top: 10px;
}
</style>